<template>
  <div class="terms-of-use ">
    
    <b-modal ref="termsOfUseModal" centered :hide-header="true" no-close-on-backdrop no-close-on-esc size="lg">
      <div class="p-4">

        <LoaderContent v-if="isLoading" />

        <h5 class="text-center">Caro candidato, antes de continuar leia nosso <router-link to="/termos-de-uso">Aviso de Tratamento de Dados Pessoais de Candidatos</router-link></h5>

        <div class="d-flex justify-content-center">
          <div class="custom-control custom-checkbox custom-checkbox-lg custom-checkbox-background mt-3">
            <input type="checkbox" class="custom-control-input" id="accept-terms" v-model="acceptTerms">
            <label class="custom-control-label" for="accept-terms">Estou ciente do Aviso de Tratamento de Dados Pessoais de Candidatos</label>
          </div>
        </div>
      </div>

      <template slot="modal-footer">
        <button type="button" class="btn btn-link" @click="notAccept()">Não, quero desistir</button>
        <button type="button" class="btn btn-color-1 text-white px-4" :disabled="!acceptTerms" @click="accept()">Sim, quero continuar</button>
      </template>
    </b-modal>

  </div>
</template>

<script>
  import CloseIcon from "vue-material-design-icons/Close.vue";
  import LoaderContent from '@/components/loader/LoaderContent.vue';

  export default {
    name: 'TermsOfUse',

    data() {
      return {
        acceptTerms: false,
        isLoading: false
      }
    },

    mounted() {
      this.$EventBus.$on('showTermsOfUse', () => {
        this.$refs['termsOfUseModal'].show();
      });
    },

    destroyed() {
      this.$EventBus.$off('showTermsOfUse');
    },

    components: {
      CloseIcon,
      LoaderContent
    },

    watch: {
      '$route.name': function(newRoute, oldRoute){
        if(this.$route.name == 'terms'){
          this.$store.commit('SET_PENDING_ACCEPT_TERMS', true);
          this.$refs['termsOfUseModal'].hide();
        }
      }
    },

    methods: {
      notAccept(){
        this.isLoading = true;

        this.$swal({
          title: 'Atenção',
          text: 'Seu usuário será removido caso não aceite os Termos de Uso.',
          type: 'error',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Remover meu usuário',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            this.$refs['termsOfUseModal'].hide();
            this.$store.dispatch('user/removeUser');
            this.$store.dispatch('user/signOut');
            this.$router.push('/');
          }
          this.isLoading = false;
        })
      },

      accept(){
        this.isLoading = true;

        this.$store.dispatch('user/acceptTermsOfUse', { source: 'carreiras' }).then( response => {
          if( response.data.acceptTermsOfUse.success ){
            this.isLoading = false;
            this.$refs['termsOfUseModal'].hide();
            this.$store.commit('SET_PENDING_ACCEPT_TERMS', false);
          }else{
            this.$swal('Uoops', 'Ocorreu um problema ao aceitar os termos. Tente novamente em instantes.', 'error').then(() => {
              this.isLoading = false;
            });
          }
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
  .terms-of-use{
    font-size: 14px;
  }
</style>